import { isFeatureEnabled } from "utility/isFeatureEnabled";

/**
 * 購入履歴（一覧・注文詳細・領収書）の取得元を購入履歴APIに切り替えるフラグ。
 * 一覧で見えた注文が詳細で引けない不整合を作らないため、画面単位ではなく機能全体で1つのキーを使う。
 * URLクエリ `?purchaseHistoryApi=1` かlocalStorageの同名キーでON、`?purchaseHistoryApi=false` で強制OFF
 */
export const usePurchaseHistoryApiFlag = (): boolean =>
  isFeatureEnabled({ featureName: "purchaseHistoryApi" });
